import * as jsonpatch from "fast-json-patch";
import { IWorkoutSetApiClients, WorkoutSetApiClients } from "./workout.set.api.client";
import { SessionSet, SetCreateRequest, SetSearchFilter, SetSearchResponse } from "src/api/entities";
// import { SetCreateRequest, SetSearchFilter, SetSearchResponse, SessionSet } from "@api/entities";

export interface IWorkoutSetApiService {
    create(workout: SetCreateRequest): Promise<SessionSet>;
    getById(id: number): Promise<SessionSet>;
    edit(oldWorkoutSet: SessionSet, updatedWorkoutSet: SessionSet): Promise<SessionSet>;
    search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string | undefined },
        filter?: SetSearchFilter
    ): Promise<SetSearchResponse>;
    createSessionSetSheet(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string | undefined },
        filter?: SetSearchFilter
    ): Promise<Blob>;
    deleteByUuid(id: string): Promise<{ [key: string]: boolean; }>
}

export class WorkoutSetApiService implements IWorkoutSetApiService {
    private static instance: WorkoutSetApiService;
    private api: IWorkoutSetApiClients;

    private constructor(basePath: string) {
        this.api = WorkoutSetApiClients.getInstance(basePath);
    }

    static getInstance(basePath: string) {
        if (WorkoutSetApiService.instance == null) {
            WorkoutSetApiService.instance = new WorkoutSetApiService(basePath);
        }
        return WorkoutSetApiService.instance;
    }

    async create(workout: SetCreateRequest): Promise<SessionSet> {
        return (await this.api.workoutSet.create3(workout)).data;
    }

    async getById(id: number): Promise<SessionSet> {
        return (await this.api.workoutSet.get1(id)).data;
    }

    async deleteByUuid(id: string): Promise<{ [key: string]: boolean; }> {
        const response: { [key: string]: boolean; } = (await this.api.workoutSet.deleteByUuid(id)).data
        return response
    }

    async edit(oldWorkoutSet: SessionSet, updatedWorkoutSet: SessionSet): Promise<SessionSet> {
        const requestPatch: any = jsonpatch.compare(oldWorkoutSet, updatedWorkoutSet);
        const workout: SessionSet = (
            await this.api.workoutSet.patch1(oldWorkoutSet.id!, requestPatch)
        ).data;
        return workout;
    }

    async search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string },
        filter?: SetSearchFilter
    ): Promise<SetSearchResponse> {
        return (
            await this.api.workoutSet.search2({
                page,
                size,
                query,
                sort,
                filter,
            })
        ).data;
    }

    async createSessionSetSheet(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string },
        filter?: SetSearchFilter
    ): Promise<Blob> {
        return (
            await this.api.workoutSet.createXls({
                page,
                size,
                query,
                sort,
                filter,
            }, { responseType: 'blob' })
        ).data as Blob;
    }
}
